export default __webpack_public_path__ + "static/media/notification.0bd4fb5b.svg";